import classNames from 'classnames';
import React from 'react';
import * as styles from './TopicActionButtons.module.scss';
import { useRightPanel } from '../app/layout/RightPanel';
import Avatar from '../components/Avatar';
import AvatarStack from '../components/AvatarStack';
import Button from '../components/Button';
import IconButton from '../components/IconButton';
import SVGIcon from '../components/SVGIcon';
import Tooltip from '../components/Tooltip';
import { BEACON_TOPIC_MEMBERS } from '../constants/onboarding';
import TopicUsersPanel from './users/TopicUsersPanel';
import type { DocumentType } from '../graphql/generated/gql';
import { gql } from '../graphql/generated/gql';
import memberIcon from '../icons/non-prefilled/16x16/member.svg';
import TutorialBeacon from '../onboarding/tutorial/TutorialBeacon';
import UserDetailPreviewPopOver from '../user/UserDetailPreviewPopOver';

const USERS_FRAGMENT = gql(`
  fragment TopicActionButtons_users on User {
    id
    ...AvatarStack_users
  }
`);

interface TopicActionButtonsProps {
  topicUsers: DocumentType<typeof USERS_FRAGMENT>[];
  limit: number;
}

const TopicActionButtons = ({ topicUsers, limit }: TopicActionButtonsProps) => {
  const { openRightPanel } = useRightPanel();
  const onShowUsers = () => openRightPanel(<TopicUsersPanel />);

  return (
    <div className={styles.container}>
      <TutorialBeacon id={BEACON_TOPIC_MEMBERS}>
        {(beaconProps) => (
          <div {...beaconProps}>
            {topicUsers.length > 0 ? (
              <Button onClick={onShowUsers}>
                <AvatarStack
                  items={topicUsers}
                  limit={limit}
                  countOverflowTooltip="View members"
                  size={30}
                >
                  {(user, options) => (
                    <UserDetailPreviewPopOver
                      userId={user.id}
                      placement="top-start"
                      hoverDelay="fast"
                    >
                      <Avatar user={user} size={options.size} />
                    </UserDetailPreviewPopOver>
                  )}
                </AvatarStack>
              </Button>
            ) : (
              <Tooltip content="View members">
                <IconButton
                  className={classNames(
                    styles.actionButton,
                    styles.membersButton,
                  )}
                  onClick={onShowUsers}
                  aria-label="View members"
                >
                  <SVGIcon>{memberIcon}</SVGIcon>
                </IconButton>
              </Tooltip>
            )}
          </div>
        )}
      </TutorialBeacon>
    </div>
  );
};

export default TopicActionButtons;
